import {useState} from 'react'
import './index.css'

const TodoItem = props => {
  const {todoDetails, deleteTodo, handleToggle, updateTodo} = props
  const {id, title, checked} = todoDetails

  const [isEditing, setIsEditing] = useState(false)
  const [editText, setEditText] = useState(title)

  const onSave = () => {
    updateTodo(id, editText)
    setIsEditing(false)
  }

  return (
    <li className="todo-item">
      <input
        type="checkbox"
        checked={checked}
        onChange={() => handleToggle(id)}
      />

      {isEditing ? (
        <input
          type="text"
          className="text-editor"
          value={editText}
          onChange={e => setEditText(e.target.value)}
        />
      ) : (
        <p
          className={`title ${checked ? 'marked-text' : ''}`}
          onClick={() => setIsEditing(true)}
        >
          {title}
        </p>
      )}

      {isEditing ? (
        <button type="button" className="save-btn" onClick={onSave}>
          Save
        </button>
      ) : (
        <button
          type="button"
          className="edit-btn"
          onClick={() => setIsEditing(true)}
        >
          Edit
        </button>
      )}

      <button type="button" className="btn" onClick={() => deleteTodo(id)}>
        Delete
      </button>
    </li>
  )
}

export default TodoItem
